'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertActionToTrackingData = exports.actionsToTrack = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _trackingEventsData;

var _package = require('../../../package.json');

var _constants = require('./../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trackingEventsData = (_trackingEventsData = {}, (0, _defineProperty3.default)(_trackingEventsData, _constants.FORM_INITIALIZED, {
    eventName: _constants.TRACKING_EVENT_NAME_FORM_DISPLAYED,
    prepareTrackingData: function prepareTrackingData() {}
}), (0, _defineProperty3.default)(_trackingEventsData, _constants.FORM_INITIALIZATION_FAILED, {
    eventName: _constants.TRACKING_EVENT_NAME_INIT_ERROR,
    prepareTrackingData: function prepareTrackingData() {}
}), (0, _defineProperty3.default)(_trackingEventsData, _constants.LOGIN_BUTTON_CLICKED, {
    eventName: _constants.TRACKING_EVENT_NAME_FORM_SUBMIT,
    prepareTrackingData: function prepareTrackingData() {}
}), (0, _defineProperty3.default)(_trackingEventsData, _constants.REGISTRATION_CLICKED, {
    eventName: _constants.TRACKING_EVENT_NAME_FORM_INTERACT,
    prepareTrackingData: function prepareTrackingData() {
        return {
            formFieldName: 'joinNowClicked'
        };
    }
}), (0, _defineProperty3.default)(_trackingEventsData, _constants.EVENT_TO_TRACK_CUSTOM, {}), _trackingEventsData);

var actionsToTrack = (0, _keys2.default)(trackingEventsData);

/**
 * Returns tracking event name and data for particular action
 * @param {Object} action Action of any of tracking events
 * @returns {Object} Object with eventName and tracking data
 */
var convertActionToTrackingData = function convertActionToTrackingData(action) {
    var type = action.type;
    var eventName = action.eventName || trackingEventsData[type].eventName;
    var trackingData = action.trackingData || trackingEventsData[type].prepareTrackingData(action);

    return (0, _assign2.default)({}, { eventName: eventName }, trackingData, { formVersion: _package.version });
};

exports.actionsToTrack = actionsToTrack;
exports.convertActionToTrackingData = convertActionToTrackingData;
//# sourceMappingURL=tracking.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/login-component/tracking.js
// module id = 489
// module chunks = 0